import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaUserCog } from "react-icons/fa";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { BsSendFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const convertToCSV = (data) => {
  const headers = [
    "ID",
    "Name",
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "employee_id",
    "position",
    "unit_id",
    "Permissions",
  ];

  const csvRows = [
    headers.join(","),
    ...data.map((row) =>
      [
        row.id,
        row.name,
        row.first_name,
        row.last_name,
        row.email,
        row.phone_number,
        row.employee_id,
        row.position,
        row.unit_id,
        row.type,
      ]
        .map((field) => `"${field ?? ""}"`) // wrap in quotes and handle null
        .join(",")
    ),
  ];
  return csvRows.join("\n");
};

const Administration = () => {
  const [t] = useTranslation();
  const history = useHistory();
  const userOrganizations = useSelector(
    (state) => state.userOrganizations.organizations
  );
  const [bulkData, setBulkData] = useState([]);
  const [loading, setLoading] = useState(false);
  const jwtToken = localStorage.getItem("jwt_token");
  const organizationId = localStorage.getItem("organisation_id");
  const userID = localStorage.getItem("user_id");
  const [file, setFile] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);

  const handleChange = (files) => {
    setFile(files[0]);
  };

  const BulkData = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/organization-employee-list?id=${organizationId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    )
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          setBulkData(data.data);
        }
        return Promise.reject(data.error);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    BulkData();
  }, []);

  const onSubmitHandler = () => {
    if (!file) {
      toast.error("Please select a file before submitting.");
      return;
    }
    setLoading(true);
    const bodyFormData = new FormData();
    bodyFormData.append("file", file);
    bodyFormData.append("organization_id", organizationId);

    fetch(`${process.env.REACT_APP_API_URL}/employee-list/upload-file`, {
      method: "POST",
      body: bodyFormData,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          toast.success(data.message);
        }
        BulkData();
        setLoading(false);
        return Promise.reject(data.error);
      })
      .catch((error) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const [showEmployeeList, setEmployeeListShow] = useState(true);

  const clicktoShowListhandler = () => {
    setEmployeeListShow(!showEmployeeList);
  };

  const downloadFullFileHandler = () => {
    if (bulkData.length === 0) {
      toast.error("No data available to download.");
      return;
    }

    const csvData = convertToCSV(bulkData);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Action-cards current employee list.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const sendInvite = (email, user_id) => {
    fetch(`${process.env.REACT_APP_API_URL}/resend-welcome-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ email, user_id }),
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          toast.success(data.message || "Invite sent successfully!");
        } else {
          toast.error(data.error || "Failed to send invite.");
        }
      })
      .catch((error) => {
        toast.error("Failed to send invite.");
      });
  };
  const handleDeleteClick = (item) => {
    if (item.id == userID) {
      toast.error("You can't remove your self.");
      return;
    }
    setDeleteUserId(item.id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteUserId) return;
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/remove-user-from-organisation/${deleteUserId}&${organizationId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      if (res.ok) {
        toast.success("User remove successfully");
        setShowDeleteModal(false);
        setDeleteUserId(null);
        BulkData();
      } else {
      }
    } catch (err) {
      toast.error("Error deleting user");
    }
    setLoading(false);
  };

  const { organizations } = useSelector((state) => state.userOrganizations);
  const isAdmin_Owner = organizations.some(
    (org) =>
      org.organisation_id === +localStorage.getItem("organisation_id") &&
      (org.role === "Admin" || org.role === "Owner")
  );

  // Redirect to home if not admin/owner
  useEffect(() => {
    if (!isAdmin_Owner) {
      history.replace("/");
    }
  }, [isAdmin_Owner, history]);

  return (
    <>
      <div className="container justify-content-center mt-2">
        <div className="text-center">
          <h3>
            <FaUserCog size={28} /> {t("userMenuSidebar.label.Administration")}
          </h3>
        </div>
      </div>

      <div className="row">
        {/* Remove global loader here, only show loader on the button */}
        {localStorage.getItem("type") == "Private" ? null : (
          <>
            <div className="container">
              <div className="row my-3 justify-content-center">
                <div className="col-md-6 ">
                  <h5>Upload Your File Here</h5>
                  <FileUploader
                    multiple={true}
                    handleChange={handleChange}
                    label={"Upload or drop a file right here"}
                    types={["CSV"]}
                  />
                  <h6 style={{ color: "red", fontSize: "12px" }}>
                    *Please note that an email address is required for the CSV
                    file to be added to the database. <br />
                    Without a valid email, the data will not be added.
                    Furthermore, in the column “Permissions” you can choose
                    between “Admin”, “Employee”, or “External Instructor”.
                    Please ensure that these permission levels are spelled
                    correctly. Anything else will be classified as “Employee”
                    and given permission accordingly.
                  </h6>
                </div>
              </div>

              <div className="row mb-2 justify-content-center ml-5">
                <div className="col-md-4 ">
                  <button
                    type="button"
                    className="nav-icon btn btn-lg bg_color"
                    onClick={onSubmitHandler}
                    disabled={loading}
                    style={{ position: "relative", minWidth: "120px" }}
                  >
                    {loading ? (
                      <>
                        <span>Submitting</span>
                        <span
                          className="spinner-border spinner-border-sm ml-2"
                          role="status"
                          aria-hidden="true"
                          style={{ verticalAlign: "middle" }}
                        ></span>
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                  <div className="mt-2">
                    <button
                      className="nav-icon btn btn-lg bg_color responsive-btn"
                      onClick={clicktoShowListhandler}
                    >
                      {showEmployeeList
                        ? "Hide Employee List"
                        : "Show Employee List"}
                    </button>
                  </div>
                </div>

                <div className="col-md-4 ">
                  <button className="nav-icon btn btn-lg bg_color mb-1 responsive-btn">
                    <a
                      href="/assets/Documents/ActionCards dummy data.csv"
                      title="click to download"
                      style={{ color: "white" }}
                      download
                    >
                      Download Demo file
                    </a>
                  </button>

                  <div className="mt-2">
                    <button
                      className="nav-icon btn btn-lg bg_color responsive-btn"
                      onClick={downloadFullFileHandler}
                    >
                      Download Full Data
                    </button>
                  </div>
                </div>
              </div>

              {!showEmployeeList && <hr />}
            </div>
          </>
        )}

        {showEmployeeList && (
          <>
            <div className="row align-items-center mb-4 mt-2">
              <div className="col-md-8 text-center">
                <h3 style={{ paddingLeft: "40%" }}>
                  {t("userMenuSidebar.label.EmployeeList")}
                </h3>
              </div>
              <div className="col-md-4 text-end">
                <Link
                  to="/administration/add"
                  className="ms-md-auto mt-2 mt-md-0"
                >
                  <button
                    type="button"
                    className="nav-icon btn btn-lg bg_color"
                    style={{
                      display: "flex",
                      width: "auto",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      marginLeft: "auto",
                    }}
                  >
                    Add User <i className="fas fa-user-plus"></i>
                  </button>
                </Link>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Name</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email Address</th>
                        <th scope="col">Phone Number</th>
                        <th scope="col">Employee ID</th>
                        <th scope="col">Position</th>
                        <th scope="col">Business Unit</th>
                        <th scope="col">Permission</th>
                        <th scope="col">Action</th>
                        {isAdmin_Owner && <th scope="col">Send Invite</th>}
                        {isAdmin_Owner && <th scope="col">Remove</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {bulkData.map((item, i) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{item.id}</th>
                            <td>{item.name}</td>
                            <td>{item.first_name}</td>
                            <td>{item.last_name}</td>
                            <td>{item.email}</td>
                            <td>{item.phone_number}</td>
                            <td>{item.employee_id}</td>
                            <td>{item.position}</td>
                            <td>{item.unit_id}</td>
                            <td>{item.type}</td>
                            <td>
                              <i
                                type="button"
                                className="nav-icon fas fa-edit btn btn-lg bg_color"
                                onClick={() => {
                                  history.push({
                                    pathname: `/administration/update`,
                                    search: `?id=${item.id}`,
                                  });
                                }}
                              ></i>
                            </td>
                            {isAdmin_Owner && (
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <BsSendFill
                                    size={30}
                                    color="#f6615f"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      sendInvite(item.email, item.id);
                                    }}
                                  />
                                </div>
                              </td>
                            )}
                            {isAdmin_Owner && (
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <MdDelete
                                    size={30}
                                    color="#f6615f"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleDeleteClick(item);
                                    }}
                                  />
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      })}

                      <tr hidden={bulkData.length !== 0}>
                        <td colSpan="5" className="text-center">
                          Data Not Found
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove this user to this organization?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Administration;
